import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_URL } from "../constant";
import { LinearProgress } from "@mui/material";
import AlertBox from "../component/AlertBox";
import { useNavigate, useParams } from "react-router-dom";
import ButtonCompo from "../component/ButtonCompo"

function MyLeaveApplication() {
  const { leaveId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveData, setLeaveData] = useState({});
  const navigate = useNavigate()
  const [somethingError, setSomethingError] = useState(false)

  // fetch leave
  async function getLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/leave/application/get/single/${leaveId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLeaveData(res.data?.data);
    } catch (error) {
      setSomethingError(true)
    } finally {
      setLoading(false);
    }
  }

  async function revokeApplication() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/leave/revoke/${leaveId}`,
        method: "get",
        withCredentials: true,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Leave has been revoked");
      navigate("/employee/leave")
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Revoke failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getLeave();
  }, [leaveId]);

  if(somethingError) {
    return (
      <div>
        <p className="w-full text-center text-slate-500 font-medium">Leave Application not found</p>
      </div>
    )
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[95vw] md:w-[30rem] p-5 border mt-5 rounded-[10px] shadow-md">
          <h1 className="text-center text-[19px] font-medium">
            Leave Application
          </h1>
          <div className="mt-7 w-full space-y-2">
            <section className="grid grid-cols-2">
              <p className="font-medium">Applicant</p>
              <p className="text-slate-700">{leaveData?.user?.fullName}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Role</p>
              <p className="text-slate-700">{leaveData?.user?.role}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Leave Type</p>
              <p className="text-slate-700">{leaveData?.leaveName?.length > 0 ? leaveData?.leaveName : leaveData?.leaveType}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">From</p>
              <p className="text-slate-700">{`${leaveData?.startDom}-${Number(leaveData?.startMonth) + 1}-${leaveData?.startYear}`}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">To</p>
              <p className="text-slate-700">{`${leaveData?.endDom}-${Number(leaveData?.endMonth) + 1}-${leaveData?.endYear}`}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Total Days</p>
              <p className="text-slate-700">{leaveData?.totalDays}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Leave Option</p>
              <p className="text-slate-700">
                {leaveData?.leaveOption === "Full"
                  ? "Full Day"
                  : leaveData?.leaveOption === "FH"
                  ? "First Half"
                  : "Second Half"}
              </p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Description</p>
              <p className="text-slate-700">{leaveData?.description}</p>
            </section>
            <section className="grid grid-cols-2">
              <p className="font-medium">Status</p>
              <p className="text-slate-700">
                {leaveData?.isApproved === undefined ? (
                  <span className="text-[13px] px-3 py-1 bg-yellow-200/40 border-yellow-300 border text-yellow-700 font-medium rounded-full">
                    Pending
                  </span>
                ) : leaveData?.isApproved === true ? (
                  <span className="text-[13px] px-3 py-1 bg-green-200/40 border-green-300 border text-green-700 font-medium rounded-full">
                    Approved
                  </span>
                ) : leaveData?.isRevoked === true ? (
                  <span className="text-[13px] px-3 py-1 bg-red-200/40 border-red-300 border text-red-700 font-medium rounded-full">
                    Revoked
                  </span>
                ) : (
                  <span className="text-[13px] px-3 py-1 bg-red-200/40 border-red-300 border text-red-700 font-medium rounded-full">
                    Rejected
                  </span>
                )}
              </p>
            </section>
          </div>
          {leaveData?.isApproved === undefined ? (
            <div className="w-full flex justify-center items-center mt-5">
              <ButtonCompo variant={"contained"} color={"error"} onClick={revokeApplication}>Revoke</ButtonCompo>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

export default MyLeaveApplication;
